(function() {
  'use strict';

  var timer = null;
  var fetching = false;
  var fetchDirty = false;
  var fetchQueue = [];
  var cache = null;
  var cacheTime = 0;
  var CACHE_MS = 3000;
  var giftSyncing = false;
  var giftSyncQueued = false;
  var giftDismissed = false;
  var SHIPPING_TIMER_KEY = 'trlab:free-shipping-timer:v1';
  var DEFAULT_SHIPPING_TIMER_MINUTES = 15;
  var shippingTickTimer = null;
  var shippingTimerStateLoaded = false;
  var shippingTimerState = null;
  var SHIPPING_UNLOCK_ATTRIBUTE = '_cart_01_shipping_unlock_count';
  var SHIPPING_COUNT_BASIS_ATTRIBUTE = '_cart_01_shipping_count_basis';
  var shippingUnlockState = null;
  var shippingUnlockWriting = false;
  var shippingUnlockQueued = null;

  function bars() {
    return document.querySelectorAll('[data-cart-reward-bar]');
  }

  function normalizeVariantId(id) {
    if (!id) return null;
    var value = String(id);
    return value.indexOf('gid://') === 0 ? value.split('/').pop() : value;
  }

  function cfg(bar) {
    if (bar._cfg) return bar._cfg;

    var discountCount = parseInt(bar.dataset.discountCount, 10) || 1;
    var shippingCount = parseInt(bar.dataset.freeShippingCount, 10) || 2;
    var shippingMinimum = Number(bar.dataset.freeShippingMinimum);
    if (!isFinite(shippingMinimum)) shippingMinimum = 7900;
    var giftCount = parseInt(bar.dataset.freeGiftCount, 10) || 5;

    if (shippingCount <= discountCount) shippingCount = discountCount + 1;
    if (giftCount <= shippingCount) giftCount = shippingCount + 1;

    var shippingTimerMinutes = parseInt(bar.dataset.freeShippingTimerMinutes, 10);
    if (!isFinite(shippingTimerMinutes)) shippingTimerMinutes = DEFAULT_SHIPPING_TIMER_MINUTES;
    shippingTimerMinutes = Math.max(1, Math.min(1440, shippingTimerMinutes));
    var copyNode = bar.querySelector('[data-cart-01-reward-copy]');
    var cart01Copy = copyNode ? JSON.parse(copyNode.getAttribute('data-cart-01-reward-copy')) : null;

    bar._cfg = {
      discountPercent: parseInt(bar.dataset.discountPercent, 10) || 10,
      discountCount: discountCount,
      shippingCount: shippingCount,
      shippingMinimum: Math.max(0, shippingMinimum),
      amountBasis: bar.dataset.freeShippingAmountBasis || 'after_discounts',
      currency: bar.dataset.currency || 'USD',
      giftEnabled: bar.dataset.freeGiftEnable === 'true',
      giftAfterPayment: bar.dataset.giftAfterPayment === 'true',
      giftAfterShipping: bar.dataset.giftAfterShipping === 'true',
      cart01Copy: cart01Copy,
      giftCount: giftCount,
      giftProductId: normalizeVariantId(bar.dataset.freeGiftProductId),
      // 兼容尚未持久化新 checkbox 的既有主题：只有明确 false 才关闭。
      shippingTimerEnabled: bar.dataset.freeShippingTimerEnable !== 'false',
      shippingTimerDurationMs: shippingTimerMinutes * 60 * 1000,
      shippingTimerMessage: bar.dataset.freeShippingTimerMessage || 'Free shipping reserved for {{ timer }}',
      shippingTimerExpiredMessage: bar.dataset.freeShippingTimerExpiredMessage || 'Your free shipping window has ended',
      // 兼容尚未持久化新 checkbox 的既有主题：只有明确 false 才隐藏过期横幅。
      shippingTimerShowExpiredMessage: bar.dataset.freeShippingTimerShowExpiredMessage !== 'false',
      beforeDiscount: bar.dataset.messageBeforeDiscount || 'Add {{ count }} more item(s) to unlock {{ percent }}% OFF',
      beforeShipping: bar.dataset.messageBeforeShipping || '{{ percent }}% off first order unlocked! Add {{ count }} more item(s) for free shipping.',
      singleItemShippingAmount: bar.dataset.messageSingleItemShippingAmount || '{{ percent }}% off first order unlocked! Add {{ amount_left }} more for free shipping.',
      beforeGift: bar.dataset.messageBeforeGift || 'FREE shipping unlocked — add {{ count }} more item(s) for a FREE gift',
      shippingAmount: bar.dataset.messageShippingAmount || 'Add {{ amount_left }} more to unlock your free shipping on orders {{ minimum_amount }}.',
      giftBeforeShipping: bar.dataset.messageGiftBeforeShipping || 'Add {{ amount_left }} more to unlock your free shipping on orders {{ minimum_amount }}.',
      complete: bar.dataset.messageComplete || 'Congratulations! All rewards unlocked'
    };
    return bar._cfg;
  }

  function invalidateCache() {
    cache = null;
    cacheTime = 0;
    if (fetching) fetchDirty = true;
  }

  // Ajax Cart 不包含变体元字段。优先复用同次 Liquid 片段，未知行等待只读快照，不能按 1 猜测。
  function withPieceData(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    function complete(data) {
      return data && cart.items.every(function(item) {
        var entry = data[item.key];
        return entry && Number.isSafeInteger(entry.units) && entry.units >= 0 && typeof entry.discountExcluded === 'boolean';
      });
    }
    if (complete(cart._pieceData)) return cart;
    var nodes = document.querySelectorAll('[data-cart-piece-data]');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var data = JSON.parse(nodes[i].getAttribute('data-cart-piece-data'));
        if (complete(data)) return Object.assign({}, cart, { _pieceData: data });
      } catch (error) { /* 缺失/损坏片段由只读快照恢复，不改变购物车。 */ }
    }
    return cart.items.length ? null : Object.assign({}, cart, { _pieceData: {} });
  }

  function readPieceCart(response) {
    if (!response.ok) throw new Error('Unable to read cart piece counts.');
    return response.json().then(function(payload) {
      var cart = payload.cart;
      if (!cart || !payload.piece_data) throw new Error('Missing cart piece counts.');
      cart._pieceData = payload.piece_data;
      var complete = withPieceData(cart);
      if (!complete) throw new Error('Incomplete cart piece counts.');
      return complete;
    });
  }

  function fetchCart() {
    var now = Date.now();
    if (cache && now - cacheTime < CACHE_MS) {
      // 新事件已提供最新快照时，在途旧请求及等待者共用该快照，避免等待队列悬空。
      while (fetchQueue.length) fetchQueue.shift()(cache);
      return Promise.resolve(cache);
    }
    if (fetching) return new Promise(function(resolve) { fetchQueue.push(resolve); });

    fetching = true;
    return fetch(shopRoot() + 'cart?view=piece-counts', { credentials: 'same-origin', cache: 'no-store' })
      .then(readPieceCart)
      .then(function(cart) {
        fetching = false;
        if (fetchDirty) {
          fetchDirty = false;
          return fetchCart();
        }
        if (cart) {
          cache = cart;
          cacheTime = Date.now();
        }
        var result = cart || cache;
        while (fetchQueue.length) fetchQueue.shift()(result);
        return result;
      })
      .catch(function() {
        fetching = false;
        if (fetchDirty) {
          fetchDirty = false;
          return fetchCart();
        }
        var result = cache;
        while (fetchQueue.length) fetchQueue.shift()(result);
        return result;
      });
  }

  function isRewardGift(item, config) {
    if (!item) return false;
    var properties = item.properties || {};
    var marker = properties._reward_gift;
    if (marker === true || marker === 'true' || marker === '1' || marker === 1) return true;

    var itemVariantId = normalizeVariantId(item.variant_id || item.id);
    var isConfiguredGift = config.giftProductId && itemVariantId === config.giftProductId;
    var isFree = Number(item.final_line_price) === 0 || Number(item.final_price) === 0;
    return Boolean(isConfiguredGift && isFree);
  }

  function rewardCounts(rawCount, items, config, discountFallback, pieceData) {
    if (!items || !items.length) {
      return {
        total: Math.max(0, rawCount || 0),
        discount: Math.max(0, typeof discountFallback === 'number' ? discountFallback : rawCount || 0)
      };
    }
    return items.reduce(function(result, item) {
      var quantity = parseInt(item.quantity, 10) || 0;
      var entry = pieceData && pieceData[item.key];
      if (entry && entry.units > 0) {
        result.total += quantity * entry.units;
        // 首档折扣仍按购买数量统计；本次只统一实物件数和免邮/赠品进度。
        if (!entry.discountExcluded) result.discount += quantity;
      }
      return result;
    }, { total: 0, discount: 0 });
  }

  function giftLines(items, config) {
    return (items || []).filter(function(item) {
      return isRewardGift(item, config);
    });
  }

  // 与 Liquid 使用同一购物车金额，包含已生效的订单折扣，不能累加行价替代。
  function shippingReached(counts, config) {
    return counts.total >= config.shippingCount && counts.subtotal >= config.shippingMinimum;
  }

  // 赠品与免邮共用金额门槛：件数达标但小计不足时，不点亮赠品图标也不同步赠品行。
  function giftReached(counts, config) {
    return config.giftEnabled && counts.total >= config.giftCount && counts.subtotal >= config.shippingMinimum;
  }

  // 只写购物车属性，不改商品或重建抽屉；连续操作合并，旧响应不得覆盖新数量。
  function saveShippingUnlock(state) {
    shippingUnlockQueued = state;
    if (shippingUnlockWriting) return;
    shippingUnlockWriting = true;
    var pending = shippingUnlockQueued;
    shippingUnlockQueued = null;
    var attributes = {};
    attributes[SHIPPING_UNLOCK_ATTRIBUTE] = pending.value ? String(pending.value) : '';
    attributes[SHIPPING_COUNT_BASIS_ATTRIBUTE] = 'pieces-v1';
    requestJSON(shopRoot() + 'cart/update.js', { attributes: attributes }).then(function (cart) {
      if (Number((cart.attributes || {})[SHIPPING_UNLOCK_ATTRIBUTE] || 0) !== pending.value || (cart.attributes || {})[SHIPPING_COUNT_BASIS_ATTRIBUTE] !== 'pieces-v1') throw new Error('Reward threshold was not saved.');
      if (shippingUnlockState && shippingUnlockState.token === pending.token) shippingUnlockState.saved = pending.value;
      if (cache && String(cache.token || '') === pending.token) cache.attributes = Object.assign({}, cache.attributes, attributes);
    }).catch(function (error) {
      console.warn('[CartRewardBar] ' + error.message);
    }).then(function () {
      shippingUnlockWriting = false;
      var queued = shippingUnlockQueued;
      shippingUnlockQueued = null;
      if (queued && (queued.token !== pending.token || queued.value !== pending.value)) saveShippingUnlock(queued);
    });
  }

  function updateGiftThreshold(bar, counts, config, cart) {
    if (!config.giftAfterShipping || !config.giftEnabled) return;
    var stored = Math.max(0, Number(cart ? (cart.attributes || {})[SHIPPING_UNLOCK_ATTRIBUTE] : bar.dataset.shippingUnlockCount) || 0);
    if (cart && (cart.attributes || {})[SHIPPING_COUNT_BASIS_ATTRIBUTE] !== 'pieces-v1') stored = 0;
    var baseline = stored;
    if (cart) {
      var token = String(cart.token || '');
      if (!shippingUnlockState || shippingUnlockState.token !== token) shippingUnlockState = { token: token, value: stored, saved: stored };
      baseline = shippingUnlockState.value;
    }
    if (!shippingReached(counts, config)) baseline = 0;
    else if (baseline < config.shippingCount || baseline > counts.total) baseline = counts.total;
    config.giftCount = (baseline || config.shippingCount) + 1;
    bar.dataset.shippingUnlockCount = String(baseline);
    bar.dataset.freeGiftCount = String(config.giftCount);
    if (cart) {
      shippingUnlockState.value = baseline;
      if (shippingUnlockState.saved !== baseline || shippingUnlockWriting || (cart.attributes || {})[SHIPPING_COUNT_BASIS_ATTRIBUTE] !== 'pieces-v1') saveShippingUnlock({ token: shippingUnlockState.token, value: baseline });
    }
  }

  function parseShippingTimerState(raw) {
    if (!raw) return null;
    try {
      var parsed = JSON.parse(raw);
      var expiresAt = Number(parsed.expiresAt);
      if (!isFinite(expiresAt) || expiresAt <= 0) return null;
      var startedAt = Number(parsed.startedAt);
      if (!isFinite(startedAt) || startedAt <= 0) startedAt = expiresAt - (24 * 60 * 60 * 1000);
      var durationMs = Number(parsed.durationMs);
      if (!isFinite(durationMs) || durationMs <= 0) durationMs = expiresAt - startedAt;
      return {
        startedAt: startedAt,
        expiresAt: expiresAt,
        durationMs: durationMs,
        expired: parsed.expired === true
      };
    } catch (error) {
      return null;
    }
  }

  function saveShippingTimerState(state) {
    try {
      window.localStorage.setItem(SHIPPING_TIMER_KEY, JSON.stringify(state));
    } catch (error) {
      // localStorage 不可用时仅在当前页面内保持计时，不阻断购物车主链路。
    }
  }

  function getShippingTimerState(durationMs, now) {
    if (!shippingTimerStateLoaded) {
      shippingTimerStateLoaded = true;
      try {
        shippingTimerState = parseShippingTimerState(window.localStorage.getItem(SHIPPING_TIMER_KEY));
      } catch (error) {
        shippingTimerState = null;
      }
    }

    // 已经过了旧结束时间的状态先永久过期，不能因商家延长时长而复活。
    if (shippingTimerState && !shippingTimerState.expired && now >= shippingTimerState.expiresAt) {
      markShippingTimerExpired(shippingTimerState);
    }

    // 商家修改时长后，仍在进行中的计时从原 startedAt 重新计算。
    if (shippingTimerState && !shippingTimerState.expired && shippingTimerState.durationMs !== durationMs) {
      shippingTimerState.durationMs = durationMs;
      shippingTimerState.expiresAt = shippingTimerState.startedAt + durationMs;
      saveShippingTimerState(shippingTimerState);
    }
    return shippingTimerState;
  }

  function startShippingTimer(startedAt, durationMs) {
    startedAt = Number(startedAt) || Date.now();
    shippingTimerState = {
      startedAt: startedAt,
      expiresAt: startedAt + durationMs,
      durationMs: durationMs,
      expired: false
    };
    shippingTimerStateLoaded = true;
    saveShippingTimerState(shippingTimerState);
    return shippingTimerState;
  }

  function markShippingTimerExpired(state) {
    if (state.expired) return;
    state.expired = true;
    saveShippingTimerState(state);
  }

  function formatTimerDuration(remainingMs) {
    var totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var values = hours > 0 ? [hours, minutes, seconds] : [minutes, seconds];
    return values.map(function(value) {
      return value < 10 ? '0' + value : String(value);
    }).join(':');
  }

  function renderTimerMessage(timer, template, value) {
    var before = timer.querySelector('[data-free-shipping-timer-before]');
    var valueElement = timer.querySelector('[data-free-shipping-timer-value]');
    var after = timer.querySelector('[data-free-shipping-timer-after]');
    if (!before || !valueElement || !after) return;

    var message = String(template || '');
    var placeholder = message.match(/\{\{\s*timer\s*\}\}/);
    if (placeholder) {
      before.textContent = message.slice(0, placeholder.index);
      after.textContent = message.slice(placeholder.index + placeholder[0].length);
    } else {
      before.textContent = message ? message + ' ' : '';
      after.textContent = '';
    }
    valueElement.hidden = false;
    valueElement.textContent = value;
    timer.setAttribute('aria-label', message.replace(/\{\{\s*timer\s*\}\}/g, value) || value);
  }

  function timerForBar(bar) {
    var drawer = bar.closest && bar.closest('#CartDrawer');
    // 自定义倒计时：抽屉横幅挂载在滚动区顶部（fixed-header 不再承载，避免遮挡）。
    if (drawer) return drawer.querySelector('.drawer__scrollable > [data-free-shipping-timer]');
    return bar.querySelector('[data-free-shipping-timer]');
  }

  function setShippingTimerVisibility(timerElement, visible) {
    if (!timerElement) return;
    var drawer = timerElement.closest && timerElement.closest('#CartDrawer');
    var shouldReplayDrawerEntrance = visible && timerElement.hidden && drawer &&
      document.documentElement.classList.contains('js-drawer-open') &&
      document.documentElement.getAttribute('data-disable-animations') !== 'true';

    if (!visible) timerElement.classList.remove('cart-free-shipping-timer--entering');
    if (shouldReplayDrawerEntrance) {
      // 自定义倒计时：抽屉已打开后初始化横幅时，复位到原生 appear-animation 起点再交回同一 transition。
      timerElement.classList.add('cart-free-shipping-timer--entering');
      timerElement.hidden = false;
      void timerElement.offsetHeight;
      timerElement.classList.remove('cart-free-shipping-timer--entering');
    } else {
      timerElement.hidden = !visible;
    }

    if (drawer) drawer.classList.toggle('cart-free-shipping-timer-visible', visible);
  }

  function renderShippingTimer(bar, now) {
    var timerElement = timerForBar(bar);
    var config = cfg(bar);
    if (!timerElement || !config.shippingTimerEnabled) {
      if (!timerElement && bar.closest) {
        var drawer = bar.closest('#CartDrawer');
        if (drawer) drawer.classList.remove('cart-free-shipping-timer-visible');
      }
      setShippingTimerVisibility(timerElement, false);
      return false;
    }

    var state = getShippingTimerState(config.shippingTimerDurationMs, now) || startShippingTimer(now, config.shippingTimerDurationMs);
    var expired = state.expired || now >= state.expiresAt;
    var valueElement = timerElement.querySelector('[data-free-shipping-timer-value]');
    var before = timerElement.querySelector('[data-free-shipping-timer-before]');
    var after = timerElement.querySelector('[data-free-shipping-timer-after]');

    timerElement.classList.toggle('cart-free-shipping-timer--expired', expired);

    if (expired) {
      markShippingTimerExpired(state);
      if (!config.shippingTimerShowExpiredMessage) {
        setShippingTimerVisibility(timerElement, false);
        return false;
      }
      setShippingTimerVisibility(timerElement, true);
      if (before) before.textContent = config.shippingTimerExpiredMessage;
      if (valueElement) {
        valueElement.textContent = '';
        valueElement.hidden = true;
      }
      if (after) after.textContent = '';
      timerElement.setAttribute('aria-label', config.shippingTimerExpiredMessage);
      return false;
    }

    setShippingTimerVisibility(timerElement, true);
    renderTimerMessage(timerElement, config.shippingTimerMessage, formatTimerDuration(Math.min(config.shippingTimerDurationMs, state.expiresAt - now)));
    return timerElement.getClientRects().length > 0;
  }

  function scheduleShippingTimerTick(shouldTick) {
    if (shippingTickTimer) {
      clearTimeout(shippingTickTimer);
      shippingTickTimer = null;
    }
    if (!shouldTick || document.hidden) return;
    var delay = 1000 - (Date.now() % 1000) + 20;
    shippingTickTimer = setTimeout(tickShippingTimers, delay);
  }

  function tickShippingTimers() {
    var all = bars();
    var now = Date.now();
    var shouldTick = false;
    for (var i = 0; i < all.length; i++) {
      if (renderShippingTimer(all[i], now)) shouldTick = true;
    }
    scheduleShippingTimerTick(shouldTick);
  }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function requestJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      body: JSON.stringify(payload),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      }
    }).then(function(response) {
      if (response.ok) return response.json();
      return response.json().catch(function() { return {}; }).then(function(error) {
        throw new Error(error.description || error.message || 'Unable to update the free gift.');
      });
    });
  }

  function fetchFreshCart() {
    return fetch(shopRoot() + 'cart?view=piece-counts&t=' + Date.now(), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(readPieceCart);
  }

  function addRewardGift(config) {
    return requestJSON(shopRoot() + 'cart/add.js', {
      items: [{
        id: config.giftProductId,
        quantity: 1,
        properties: { _reward_gift: 'true' }
      }]
    }).then(fetchFreshCart);
  }

  function updateRewardGiftLines(lines, quantity) {
    var updates = {};
    lines.forEach(function(item, index) {
      updates[item.key] = index === 0 ? quantity : 0;
    });
    return requestJSON(shopRoot() + 'cart/update.js', { updates: updates });
  }

  function publishGiftCart(cart) {
    cache = cart;
    cacheTime = Date.now();
    render(cart.item_count, cart.items || [], undefined, cart);
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart: cart, _rewardBarInternal: true }
    }));
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function syncRewardGift(cart) {
    cart = withPieceData(cart);
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(cart);
    var firstBar = bars()[0];
    if (!firstBar) return Promise.resolve(cart);

    var config = cfg(firstBar);
    if (!config.giftAfterPayment && (!config.giftEnabled || !config.giftProductId)) return Promise.resolve(cart);

    if (giftSyncing) {
      giftSyncQueued = true;
      return Promise.resolve(cart);
    }

    var count = rewardCounts(cart.item_count, cart.items, config, undefined, cart._pieceData).total;
    // 付款后赠送由商家后台负责；只清理本主题标记的历史赠品，不删除普通购买的同款商品。
    var lines = config.giftAfterPayment ? cart.items.filter(function(item) {
      return ['true', '1'].indexOf(String((item.properties || {})._reward_gift)) !== -1;
    }) : giftLines(cart.items, config);
    var subtotal = Number(cart[config.amountBasis === 'before_discounts' ? 'original_total_price' : 'total_price']) || 0;
    var shouldHaveGift = !config.giftAfterPayment && count >= config.giftCount && subtotal >= config.shippingMinimum;
    var mutation = null;

    if (!shouldHaveGift) giftDismissed = false;

    if (shouldHaveGift && lines.length === 0 && !giftDismissed) {
      mutation = addRewardGift(config);
    } else if (!shouldHaveGift && lines.length) {
      mutation = updateRewardGiftLines(lines, 0);
    }

    if (!mutation) return Promise.resolve(cart);

    giftSyncing = true;
    return mutation
      .then(function(updatedCart) {
        publishGiftCart(updatedCart);
        return updatedCart;
      })
      .catch(function(error) {
        console.warn('[CartRewardBar] ' + error.message);
        return cart;
      })
      .then(function(result) {
        giftSyncing = false;
        if (giftSyncQueued) {
          giftSyncQueued = false;
          setTimeout(function() { syncRewardGift(cache); }, 0);
        }
        return result;
      });
  }

  function progressFor(counts, config) {
    var totalCount = counts.total;
    var discountCount = counts.discount;
    if (totalCount <= 0 && discountCount <= 0) return 0;
    if (shippingReached(counts, config)) {
      if (!config.giftEnabled || totalCount >= config.giftCount) return 100;
      return 50 + ((totalCount - config.shippingCount) / (config.giftCount - config.shippingCount) * 33.3333);
    }
    var discountPosition = config.giftEnabled ? 16.6667 : 25;
    var shippingPosition = config.giftEnabled ? 50 : 75;
    if (discountCount >= config.discountCount || totalCount >= config.shippingCount) {
      var ratio = Math.min(1, Math.max(0, (totalCount - config.discountCount) / (config.shippingCount - config.discountCount)));
      if (config.shippingMinimum > 0) ratio = Math.min(ratio, counts.subtotal / config.shippingMinimum);
      // 第二阶段未达成时保留 10 个百分点，明确区分“即将达到”与“已经达到”。
      return Math.min(shippingPosition - 10, discountPosition + ratio * (shippingPosition - discountPosition));
    }
    return discountCount / config.discountCount * discountPosition;
  }

  function formatRewardMoney(amount, config, trimTrailingZeros) {
    // 差额保留分，避免 0.01 被取整；整数门槛省略无意义的 .00。
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: config.currency, currencyDisplay: 'narrowSymbol',
      minimumFractionDigits: trimTrailingZeros ? 0 : 2, maximumFractionDigits: 2
    }).format(amount / 100);
  }

  function formatMessage(template, count, config, subtotal) {
    return String(template)
      .replace(/\{\{\s*count\s*\}\}/g, String(Math.max(0, count)))
      .replace(/\{\{\s*percent\s*\}\}/g, String(config.discountPercent))
      .replace(/\{\{\s*shipping_count\s*\}\}/g, String(config.shippingCount))
      .replace(/\{\{\s*amount_basis\s*\}\}/g, config.amountBasis === 'before_discounts' ? 'before discounts' : 'after discounts')
      .replace(/\{\{\s*minimum_amount\s*\}\}/g, formatRewardMoney(config.shippingMinimum, config, true))
      .replace(/\{\{\s*amount_left\s*\}\}/g, formatRewardMoney(Math.max(0, config.shippingMinimum - (subtotal || 0)), config));
  }

  function getMessage(counts, config) {
    var giftUnlocked = giftReached(counts, config);
    if (shippingReached(counts, config)) {
      if (!config.giftEnabled || giftUnlocked) return formatMessage(config.complete, 0, config, counts.subtotal);
      return formatMessage(config.beforeGift, config.giftCount - counts.total, config, counts.subtotal);
    }
    if (counts.total >= config.shippingCount) {
      // 赠品档件数已满但金额不足：使用独立的赠品金额缺口文案（赠品图标仍未点亮）。
      var giftAmountPending = config.giftEnabled && counts.total >= config.giftCount;
      return formatMessage(giftAmountPending ? config.giftBeforeShipping : config.shippingAmount, 0, config, counts.subtotal);
    }
    if (counts.discount >= config.discountCount) {
      // 单件金额不足时提示金额缺口，与 Liquid 首屏保持一致。
      if (counts.total === 1 && counts.subtotal < config.shippingMinimum) {
        return formatMessage(config.singleItemShippingAmount, config.shippingCount - counts.total, config, counts.subtotal);
      }
      return formatMessage(config.beforeShipping, config.shippingCount - counts.total, config, counts.subtotal);
    }
    return formatMessage(config.beforeDiscount, config.discountCount - counts.discount, config, counts.subtotal);
  }

  function cart01Message(counts, config) {
    var copy = config.cart01Copy;
    var message = copy.pending, caption = copy.shippingCaption;
    var remaining = Math.max(0, config.shippingCount - counts.total);
    if (!counts.total) { message = copy.empty; caption = copy.emptyCaption; }
    else if (shippingReached(counts, config)) {
      caption = copy.securedCaption;
      if (!config.giftEnabled || giftReached(counts, config)) { message = copy.complete; caption = copy.completeCaption; }
      else { remaining = config.giftCount - counts.total; message = remaining === 1 ? copy.gift : copy.gifts; }
    } else if (counts.total >= config.shippingCount) message = copy.amount;
    else if (counts.subtotal >= config.shippingMinimum) message = remaining === 1 ? copy.item : copy.items;
    return { message: formatMessage(message, remaining, config, counts.subtotal), caption: formatMessage(caption, remaining, config, counts.subtotal) };
  }

  function render(rawCount, items, discountFallback, cart) {
    if (cart) {
      cart = withPieceData(cart);
      if (!cart) return;
    }
    rawCount = Math.max(0, rawCount || 0);
    items = items || [];

    var all = bars();
    var shouldTickShippingTimer = false;
    var now = Date.now();
    for (var i = 0; i < all.length; i++) {
      var bar = all[i];
      var config = cfg(bar);
      var counts = rewardCounts(rawCount, items, config, discountFallback, cart && cart._pieceData);
      var subtotal = cart ? cart[config.amountBasis === 'before_discounts' ? 'original_total_price' : 'total_price'] : bar.dataset.rewardSubtotal;
      counts.subtotal = Math.max(0, Number(subtotal) || 0);
      updateGiftThreshold(bar, counts, config, cart);
      var discountReached = counts.discount >= config.discountCount;
      var hasShipping = shippingReached(counts, config);
      var form = bar.closest('form');
      var summary = form && form.querySelector('[data-cart-piece-shipping]');
      if (summary) summary.textContent = hasShipping ? summary.dataset.freeLabel : summary.dataset.pendingLabel;
      var giftUnlocked = giftReached(counts, config);
      var complete = hasShipping && (!config.giftEnabled || giftUnlocked);

      bar.dataset.cartItemCount = String(counts.total);
      bar.dataset.discountEligibleCount = String(counts.discount);
      bar.dataset.rewardSubtotal = String(counts.subtotal);

      var progress = bar.querySelector('[data-reward-progress]');
      if (progress) {
        progress.style.width = Math.min(100, progressFor(counts, config)).toFixed(2) + '%';
      }

      var message = bar.querySelector('[data-reward-message]');
      var copy = config.cart01Copy && cart01Message(counts, config);
      if (message) message.textContent = copy ? copy.message : getMessage(counts, config);
      var caption = bar.querySelector('[data-reward-caption]');
      if (caption && copy) caption.textContent = copy.caption;

      updateMilestones(bar, counts, items);
      bar.classList.toggle('cart-reward-bar--discount-reached', discountReached);
      bar.classList.toggle('cart-reward-bar--shipping-reached', hasShipping);
      bar.classList.toggle('cart-reward-bar--gift-reached', giftUnlocked);
      bar.classList.toggle('cart-reward-bar--complete', complete);
      if (renderShippingTimer(bar, now)) shouldTickShippingTimer = true;
    }
    scheduleShippingTimerTick(shouldTickShippingTimer);
  }

  function updateMilestones(bar, counts, items) {
    var milestones = bar.querySelectorAll('[data-milestone]');
    var config = cfg(bar);

    for (var i = 0; i < milestones.length; i++) {
      var milestone = milestones[i];
      var threshold = parseInt(milestone.dataset.threshold, 10);
      // 折扣排除品不单独点亮首档；达到后续免邮档时补亮前置图标。
      var reached = milestone.dataset.milestone === 'discount'
        ? counts.discount >= threshold || shippingReached(counts, config)
        : milestone.dataset.milestone === 'shipping' ? shippingReached(counts, config) : giftReached(counts, config);
      var wasReached = milestone.classList.contains('is-reached');

      if (reached && !wasReached) {
        milestone.classList.add('is-reached');
        bounce(milestone.querySelector('.cart-reward-bar__milestone-icon'));
      } else if (!reached && wasReached) {
        milestone.classList.remove('is-reached');
      }

      if (milestone.dataset.milestone === 'gift' && config.giftProductId && items.length) {
        var hasGift = items.some(function(item) { return isRewardGift(item, config); });
        milestone.classList.toggle('has-gift', hasGift);
      }
    }
  }

  function bounce(element) {
    if (!element || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    element.classList.remove('is-bouncing');
    void element.offsetWidth;
    element.classList.add('is-bouncing');
    setTimeout(function() { element.classList.remove('is-bouncing'); }, 600);
  }

  function refresh(delay) {
    if (!bars().length) return;
    if (timer) clearTimeout(timer);
    timer = setTimeout(function() {
      fetchCart().then(function(cart) {
        if (cart) {
          render(cart.item_count, cart.items || [], undefined, cart);
          syncRewardGift(cart);
        }
      });
    }, delay || 200);
  }

  function onCartUpdate(event) {
    if (!bars().length) return;
    var cart = event && event.detail && event.detail.cart;
    if (!cart || typeof cart.item_count === 'undefined') return;
    cart = withPieceData(cart);
    if (!cart) { invalidateCache(); refresh(100); return; }
    var isInternal = Boolean(event.detail && event.detail._rewardBarInternal);
    var previousCart = cache;

    if (!isInternal && previousCart && previousCart.items && cart.items) {
      var firstBar = bars()[0];
      if (firstBar) {
        var config = cfg(firstBar);
        var previousGiftLines = giftLines(previousCart.items, config);
        var nextGiftLines = giftLines(cart.items, config);
        var nextCount = rewardCounts(cart.item_count, cart.items, config, undefined, cart._pieceData).total;
        if (nextCount < config.giftCount) {
          giftDismissed = false;
        } else if (previousGiftLines.length && !nextGiftLines.length) {
          giftDismissed = true;
        }
      }
    }

    cache = cart;
    cacheTime = Date.now();
    // 已有请求可能携带旧折扣金额，返回时必须重新读取，避免覆盖这份新快照。
    if (fetching) fetchDirty = true;
    render(cart.item_count, cart.items || [], undefined, cart);
    if (!isInternal) syncRewardGift(cart);
  }

  function onCartRendered(event) {
    if (!bars().length) return;
    // Cart 01 的同次响应已含最终购物车；只刷新新挂载节点，避免重复 GET 和等待。
    var cart = event && event.detail && event.detail.cart;
    cart = withPieceData(cart);
    if (cart && typeof cart.item_count === 'number') {
      if (timer) clearTimeout(timer);
      cache = cart;
      cacheTime = Date.now();
      if (fetching) fetchDirty = true;
      render(cart.item_count, cart.items || [], undefined, cart);
      return;
    }
    invalidateCache();
    refresh(100);
  }

  function onProductAdded(event) {
    if (event && event.detail && (event.detail._rewardBarInternal || event.detail._upsellInternal)) return;
    // 即使金额门槛为 0，也等待服务端件数，避免新套装或赠品使用购买数量乐观解锁。
    invalidateCache();
    refresh(500);
  }

  function onUpsellAdded() {
    invalidateCache();
    refresh(300);
  }

  document.addEventListener('cart:updated', onCartUpdate);
  document.addEventListener('cart:rendered', onCartRendered);
  document.addEventListener('ajaxProduct:added', onProductAdded);
  document.addEventListener('drawerOpen', function() { tickShippingTimers(); refresh(150); });
  document.addEventListener('drawerOpen.CartDrawer', function() { tickShippingTimers(); refresh(150); });
  document.addEventListener('cart:open', function() { tickShippingTimers(); refresh(150); });
  document.addEventListener('upsell:product:added', onUpsellAdded);
  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      scheduleShippingTimerTick(false);
    } else {
      tickShippingTimers();
    }
  });
  window.addEventListener('storage', function(event) {
    if (event.key !== SHIPPING_TIMER_KEY) return;
    shippingTimerStateLoaded = true;
    shippingTimerState = parseShippingTimerState(event.newValue);
    tickShippingTimers();
  });

  function init() {
    var all = bars();
    if (all.length) {
      render(
        parseInt(all[0].dataset.cartItemCount, 10) || 0,
        [],
        parseInt(all[0].dataset.discountEligibleCount, 10) || 0
      );
    }
  }

  function destroy() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (shippingTickTimer) {
      clearTimeout(shippingTickTimer);
      shippingTickTimer = null;
    }
    fetching = false;
    fetchDirty = false;
    fetchQueue = [];
    cache = null;
    cacheTime = 0;
    giftSyncing = false;
    giftSyncQueued = false;
    giftDismissed = false;
    shippingUnlockState = null;
    shippingTimerStateLoaded = false;
    shippingTimerState = null;
    var timerDrawers = document.querySelectorAll('#CartDrawer.cart-free-shipping-timer-visible');
    for (var d = 0; d < timerDrawers.length; d++) {
      timerDrawers[d].classList.remove('cart-free-shipping-timer-visible');
    }
    var all = bars();
    for (var i = 0; i < all.length; i++) delete all[i]._cfg;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CartRewardBar = { init: init, destroy: destroy };
})();
